import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgOtpInputComponent } from 'ng-otp-input';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.scss']
})
export class VerifyOtpComponent implements OnInit {
  @ViewChild('ngMobileOtpInput') ngMobileOtpInputRef: any;
  resendotp: boolean = false;

  config = {
    allowNumbersOnly: true,
    length: 6,
    inputStyles: {
      color: 'rgba(0, 0, 0, 0.3)',
      fontSize:'25px'
    },
  };
  constructor(private router: Router,public dialogRef: MatDialogRef<VerifyOtpComponent>) { }

  ngOnInit(): void {    
    setTimeout(()=>{         
      this.resendotp = true;
   }, 2000);  
  }

  onMobileOtpChange(otp:any) {
    // console.log(otp);    
  }

  goDashboard() {
    this.dialogRef.close();
    if(window.location.href.includes('ifa'))
    {
      this.router.navigate(['/ifa/dashboard']);
    }else{
      this.router.navigate(['/dashboard']);
    }
  }

}
